<template>
  <div class='Header'>
    <div class="banner" v-show="isShowBanner && banner && banner.image">
      <a class="banner-main" :href="banner.link" target="_blank" :style="{backgroundImage: `url(${banner.image})`}">
        <div class="banner-close"><i class="iconfont iconguanbi1" @click.stop.prevent="isShowBanner = false"></i></div>
      </a>
    </div>
    <div class="header header-v3 row bg_fff color_40" :style="{top: isShowBanner && banner && banner.image ? '50px' : '0'}" >
      <div class="header-content pr">

        <!-- logo -->
        <a href="/talent"><img class="index-logo" src="https://files.wondercv.com/bldyldylogo.png" alt="超级简历WonderCV LOGO"></a>

        <div class="middle">
          <a v-for="item in navBar" :key="item.url" :href="item.url" class="middle-item">
            {{ item.title }}
          </a>
        </div>

        <!-- 右侧信息/登录注册按钮 -->
        <div class="header-right d-flex align-items-center justify-content-end">
          <!-- 未登录状态 -->
          <template v-if="!userToken">

            <div class="account flex" >
              <a class="login" @click="storeLocation('/signin?account_type=hr_account')">登录</a>
              <a class="registered" @click="storeLocation('/signin?account_type=hr_account')">注册</a>
            </div>

          </template>
          <!-- 已经登录，有会员 -->
          <template v-else>
            <!-- 个人信息 -->
            <div class="person">
              <div class="header-personal-center">
                <div class="header-personal-center-menu dropdown pull-right pr">
                  <img class="person-icon" :src="userInfo.wechat_avatar || getHeadImg('round', userToken)" />
                  <ul class="dropdown-menu" aria-labelledby="下拉框">
                    <li>
                      <a href="/talent/users" target="_blank" style="margin:0 18px; padding:3px 2px !important; border-bottom: 1px solid #ececec;">
                        <span class="menu-item-icon" style="margin-left:18px;margin-right:23px;">
                          <img src="https://files.wondercv.com/searchResume_pc/setup-icon.png" class="pr" width="16px" style="margin-left:-4px;top:-1;">
                        </span>账户设置
                      </a>
                    </li>
                    <li>
                      <a href="/talent/userinfo" target="_blank" style="margin:0 18px; padding:3px 2px !important; border-bottom: 1px solid #ececec;">
                        <span class="menu-item-icon">
                          <img src="https://files.wondercv.com/userinfo-icon.png" width="16px" style="margin-left:-4px;">
                        </span>个人信息
                      </a>
                    </li>
                    <li>
                      <a href="/talent/company" target="_blank" style="margin:0 18px; padding:3px 2px !important; border-bottom: 1px solid #ececec;">
                        <span class="menu-item-icon">
                          <img src="https://files.wondercv.com/company-icon.png" width="16px" style="margin-left:-4px;">
                        </span>公司信息
                      </a>
                    </li>
                    <li>
                      <a href="/talent/greet" target="_blank">
                        <span class="menu-item-icon">
                          <img src="https://files.wondercv.com/hr_frontend/recruitment-settings-icon.png" width="16px" style="margin-left:-4px;">
                        </span>招聘设置
                      </a>
                    </li>
                    <li>
                      <a href="/talent/order" target="_blank">
                        <span class="menu-item-icon">
                          <img src="https://files.wondercv.com/searchResume_pc/my-order-icon.png" width="16px" style="margin-left:-4px;">
                        </span>我的订单
                      </a>
                    </li>
                    <li style="border-top: 6px solid #f9f9f9; border-bottom: 6px solid #f9f9f9; height: 64px;">
                      <a href="/jobs/">
                        <span class="menu-item-icon">
                          <img src="https://files.wondercv.com/change-icon.png" width="16px" style="margin-left:-4px;top:-1;">
                        </span>切换求职者身份
                      </a>
                    </li>
                    <li>
                      <a href="javascript:;" @click="sign_out">
                        <span class="menu-item-icon" style="margin-left:19px;margin-right:21px;">
                          <img src="https://files.wondercv.com/searchResume_pc/signout-icon.png" width="17px" class="pr" style="margin-left:-4px;">
                        </span>退出登录
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
      
    </div>
  </div>
</template>
<script>
// 所有接口
import actions from '@/actions/index'
import { get_tUser, toLogin, updateJWT } from '@/utils/utils'
import { mapState, mapMutations } from 'vuex'
import { getHeadImg } from '@/utils/static'

export default {
  data () {
    return {
      userToken:'', //判断是否登录
      userTokenNumber:0,
      hansVip:'',
      showAppQRCode:true,
      navBar: [
        {
          title: '职位管理',
          url: '/talent/joblist',
        },
        {
          title: '人才推荐',
          url: '/talent/recommend',
        },
        {
          title: '人才搜索',
          url: '/talent/search',
        },
        {
          title: '人才管理',
          url: '/talent/delivery',
        },
        {
          title: '沟通',
          url: '/talent/chat',
        },
        {
          title: '面试日历',
          url: '/talent/interview/calendar',
        },
      ],
      isShowBanner: true,
      banner: {
        image: '',
        link: ''
      }
    }
  },
  computed:{
    ...mapState('block',['userInfo']),
  },
  async created(){

    try {
      let res = await actions.company.getBanner({position: '39'})
      if (res.code === 1000) {
        this.banner.image = res.data[0].image
        this.banner.link = res.data[0].link
      }
    } catch (error) {
      console.log(error)
    }

    let user = get_tUser();
    //保存c端id
    this.userToken = user.t ||''
    if(user.t){
      // 获取默认头像
      this.userTokenNumber = user.t.charAt(user.t.length-1) || 0;
    }
    if(user.h_t){
      //更新是否完善信息(状态库)
      let userInfo = await actions.hr_accounts.getUserinfo();
      this.toggleUserInfoState(userInfo)
    }

    //console.log招聘信息
    console.log(
      "\\ \\        / /            | |          / ____\\ \\    / /\n"+
      " \\ \\  /\\  / /__  _ __   __| | ___ _ __| |     \\ \\  / / \n"+
      "  \\ \\/  \\/ / _ \\| '_ \\ / _` |/ _ \\ '__| |      \\ \\/ /  \n"+
      "   \\  /\\  / (_) | | | | (_| |  __/ |  | |____   \\  /   \n"+
      "    \\/  \\/ \\___/|_| |_|\\__,_|\\___|_|   \\_____|   \\/    \n"
    )
    console.log('%c欢迎加入超级简历 招聘地址：https://www.wondercv.com/company/0ad28612751011ea.html','color:#f00;')
    setTimeout(() => {
      // 启动Udesk
      this.loadUdesk();
    }, 1000);

    //同步窗口宽高
    this.getWindowInnerWidth();
    //同步浏览器滚动位置
    this.getScrollTop();
  },
  methods: {
    ...mapMutations('block',['updateWindowInner', 'updateScrollTop', 'updagreBodyClient', 'toggleUserInfoState']),
    getHeadImg: getHeadImg,
    //跳转登录注册方法
    storeLocation(url){
      //增加登录之后自动跳转 跳转到相应页面
      toLogin()
    },
    //退出登录
    async sign_out(){
      if(confirm('确定退出登录么？')){
        updateJWT({ jwt:'', jwt_timestamp:parseInt(new Date().getTime()/1000) });
        toLogin();
      }
    },
    // 获取浏览器窗口宽度
    getWindowInnerWidth(){
      this.updateWindowInner({width:window.innerWidth,height:window.innerHeight});
      window.addEventListener('resize', ()=>{
        this.updateWindowInner({width:window.innerWidth,height:window.innerHeight});
        //同步浏览器滚动位置
        this.updateScrollTop(document.documentElement.scrollTop || document.body.scrollTop)
        this.updagreBodyClient(document.body.clientHeight);
      });
    },
    //同步浏览器滚动位置
    getScrollTop(){
      this.updateScrollTop(document.documentElement.scrollTop || document.body.scrollTop)
      document.addEventListener('scroll',()=>{
        this.updateScrollTop(document.documentElement.scrollTop || document.body.scrollTop)
      },false);
    },
    // Udesk 启动客服
    async loadUdesk(){
      actions.udesk.udeskOnlineUrl({}).then(res=>{
        if(res.code === 1000){
          let { arr1, arr2 } = res.data;
          if(arr2){
            arr2 = {
              customer:arr2
            }
          }
          let udeskArray = Object.assign(arr1,arr2);
          //定时器启动
          setTimeout(() => {
            (function(a,h,c,b,f,g){
              a["UdeskApiObject"]=f;
              a[f] = a[f] || function(){(
                a[f].d=a[f].d||[]
                ).push(arguments)
              };
              g = h.createElement(c);
              g.async=1;
              g.charset="utf-8";
              g.src=b;
              c=h.getElementsByTagName(c)[0];
              c.parentNode.insertBefore(g,c)
            })(window,document,"script","//assets-cli.udesk.cn/im_client/js/udeskApi.js","ud");
            //传递信息
            ud(udeskArray);

          }, 1000);

        }
      });

      
    },
  },
}
</script>
<style lang="scss" scoped>
  .Header{
    background: #1F2A3A;
    height: 56px;
    .header{
      background: #1F2A3A;
      padding-left: 90px;
      padding-right: 46px;
      position: fixed;
      left: 0px;
      right: 0;
      top: 0;
      height: 56px;
      z-index: 8;
      box-sizing: border-box;
      min-width: 1000px;
      /*border-bottom: 1px solid #f5f5f7; */
      *{
        box-sizing: border-box;
      }
      .fa {
        display: inline-block;
        font: normal normal normal 14px/1 FontAwesome;
        font-size: inherit;
        text-rendering: auto;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
      }
      .align-items-center {
        align-items: center !important;
      }
      .d-flex {
        display: flex !important;
      }
      .pull-right>.dropdown-menu {
        right: 0;
        left: auto;
      }
      .dropdown-menu>li>a {
        display: block;
        padding: 3px 20px;
        clear: both;
        font-weight: normal;
        line-height: 1.428571429;
        color: #333333;
        white-space: nowrap;
      }

      .dropdown-menu {
        position: absolute;
        top: 100%;
        left: 0;
        z-index: 1000;
        display: none;
        float: left;
        min-width: 160px;
        padding: 5px 0;
        // margin: 2px 0 0;
        list-style: none;
        font-size: 14px;
        text-align: left;
        background-color: #fff;
        border: 1px solid #ccc;
        border: 1px solid rgba(0,0,0,0.15);
        border-radius: 4px;
        -webkit-box-shadow: 0 6px 12px rgba(0,0,0,0.175);
        box-shadow: 0 6px 12px rgba(0,0,0,0.175);
        background-clip: padding-box;
        &.dropdown-menu {
          width: 241px;
          transition: none;
          -moz-transition: none;
          -webkit-transition: none;
          -o-transition: none;
        }
      }
      .header-personal-center {
        height: 56px;
        line-height: 56px;
        .header-personal-center-menu {
          height: 56px;
          line-height: 56px;
          text-decoration: none;
          width: 56px;
          text-align: center;
          cursor: pointer;
          .person-icon{
            width: 28px;
            height: 28px;
            // display: block;
            border-radius: 50%;
            object-fit: contain;
          }
          .dropdown-menu {
            width: 200px;
            li {
              height: 52px;
              a {
                height: 52px;
                line-height: 52px;
                .menu-item-icon {
                  margin-left: 20px;
                  margin-right: 19px;
                }
                &:hover{
                  color: #000;
                }
              }
            }
          }
          &:hover{
            .dropdown-menu{
              display: block;
            }
          }
        }
      }

    }
    .header-v3{
      .divide {
        height: 26px;
        width: 2px;
        background: #DEDFE1;
        margin-right: 12px;
      }
      img {
        vertical-align: middle;
        display: inline-block;
      }
      .header-content {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .index-logo {
          width: 102;
          height: 34px;
        }

        .middle {
          display: flex;
          .middle-item {
            &:hover {
              font-weight: 600;
            }
            margin-right: 38px;
            text-align: center;
            color: #fff;
            height: 55px;
            line-height: 55px;
            cursor: pointer;
            flex-shrink: 0;
          }
        }
        
        /* 右侧信息(用户信息/登录注册) */
        .header-right{
          .account {
            justify-content: space-between;
            width: 172px;
          }
          .login {
            width: 76px;
            height: 30px;
            border-radius: 15px;
            border: 1px solid #797B7E;
            font-size: 14px;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 30px;
            text-align: center;
            &:hover{
              background: #FF6644;
              cursor: pointer;
              border: none;
            }
          }
          .registered {
            width: 76px;
            height: 30px;
            background: #FF6644;
            border-radius: 15px;
            font-size: 14px;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 30px;
            text-align: center;
            &:hover{
              cursor: pointer;
              background: #FF856A;
            }
          }
          .dropdown-menu {
            margin-left: 0 !important;
            i,img{
              margin-right: 6px;
              margin-left: -2px;
            }
          }
        }
      }
    }
    .banner {
      width: 100%;
      height: 50px;
      position: fixed;
      top: 0;
      left: 0;
      background: #fff;
      z-index: 10;
      .banner-main {
        display: block;
        max-width: 2000px;
        min-width: 1200px;
        height: 100%;
        margin: auto;
        background-size: 2000px 50px;
        background-position: 50%;
        position: relative;
        .banner-close {
          height: 100%;
          line-height: 50px;
          width: 1200px;
          margin: auto;
          color: #fff;
          text-align: right;
          .iconfont {
            font-size: 24px;
            margin-right: 0px;
            cursor: pointer;
          }
        }
      }
    }
  }

</style>
